import { render } from "./ForbiddenNameListView.vue?vue&type=template&id=01b70050&scoped=true"
import script from "./ForbiddenNameListView.vue?vue&type=script&lang=js"
export * from "./ForbiddenNameListView.vue?vue&type=script&lang=js"

import "./ForbiddenNameListView.vue?vue&type=style&index=0&id=01b70050&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b70050"]])

export default __exports__